export const DB_SUCCESS = 0;
export const DB_ERROR_ANY = 1;
export const DB_ERROR_CONFLICT = 2;
